// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1vszG","question":"Question_question__3_6Si","description":"Question_description__grOg8"};